export default function Support() {
  return (
    <>
      <div className="screen active" id="screen-support">
        <div className="page-head">
          <div>
            <h1>Support</h1>
            <div className="ph-sub">
              Raise and track tickets with CorpBills operations
            </div>
          </div>
          <div className="page-actions">
            <button
              className="btn btn-primary btn-sm"
              onclick="toggleTicketForm()"
            >
              New ticket
            </button>
          </div>
        </div>
        <div
          className="card"
          id="ticket-form-card"
          style={{ display: "none", marginBottom: 18 }}
        >
          <div className="card-title">Create ticket</div>
          <div className="form-grid">
            <div className="field">
              <label>Category</label>
              <select id="ticket-cat">
                <option>Payment failed</option>
                <option>Account linking</option>
                <option>Refund</option>
                <option>Fund credit delay</option>
                <option>Other</option>
              </select>
            </div>
            <div className="field">
              <label>Priority</label>
              <select id="ticket-priority">
                <option>Low</option>
                <option>Medium</option>
                <option>High</option>
              </select>
            </div>
          </div>
          <div className="field">
            <label>Subject</label>
            <input
              type="text"
              id="ticket-subject"
              placeholder="Short summary"
            />
          </div>
          <div className="field">
            <label>Description</label>
            <textarea
              rows={3}
              id="ticket-desc"
              placeholder="Describe the issue"
              defaultValue={""}
            />
          </div>
          <div className="field">
            <label>Attachment</label>
            <input type="file" />
          </div>
          <button className="btn btn-primary" onclick="submitTicket()">
            Submit ticket
          </button>
        </div>
        <div className="card">
          <div className="table-wrap">
            <table className="data-table" id="ticket-table">
              <tbody>
                <tr>
                  <th>Ticket</th>
                  <th>Category</th>
                  <th>Priority</th>
                  <th>Status</th>
                  <th className="tright">Updated</th>
                </tr>
                <tr>
                  <td className="mono">TCK-3391</td>
                  <td>Payment failed</td>
                  <td>
                    <span className="pill pill-failed">High</span>
                  </td>
                  <td>
                    <span className="pill pill-pending">Open</span>
                  </td>
                  <td className="tright" style={{ color: "var(--text-faint)" }}>
                    2 hours ago
                  </td>
                </tr>
                <tr>
                  <td className="mono">TCK-3380</td>
                  <td>Fund credit delay</td>
                  <td>
                    <span className="pill pill-pending">Medium</span>
                  </td>
                  <td>
                    <span className="pill pill-pending">In progress</span>
                  </td>
                  <td className="tright" style={{ color: "var(--text-faint)" }}>
                    Yesterday
                  </td>
                </tr>
                <tr>
                  <td className="mono">TCK-3362</td>
                  <td>Account linking</td>
                  <td>
                    <span className="pill pill-neutral">Low</span>
                  </td>
                  <td>
                    <span className="pill pill-success">Resolved</span>
                  </td>
                  <td className="tright" style={{ color: "var(--text-faint)" }}>
                    4 days ago
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
